import { useIonRouter, useIonViewWillEnter, IonIcon, IonChip, IonRefresher, IonRefresherContent, IonCardContent, IonText, IonGrid, IonRow, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import './Main.css'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement } from "../components/NServer";
import NumInputCtrl from "../components/NumInputCtrl";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

const NtkExchange : React.FC = () => {
    
    const [nToken, setNToken] = useState("");
    const [totalToken, setTotalToken] = useState("");
    const [ntkExchange, setNTKExchange] = useState("");
    const [amount, setAmount] = useState("0");

    //	Initializing our router
	const router = useIonRouter();

    const numberWithCommas = (x : string) => {
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    useIonViewWillEnter(() => {
        Refresh();
    });

    const Refresh = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("wallet_info", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            return;
        }
        
        setTotalToken(server.data.ntoken);
        setNTKExchange(server.data.ntk_exchange);
        setAmount("0");
        setNToken(server.data.ntoken);
    };

    const doRefresh = async (ev : any) => {
        await Refresh();
        ev.detail.complete();
    }

    const exchangeRate = (token : string) => {
        router.push("/exchangerate/" + token, "forward", "push");
    }

    const useMax = () => {
        let pExchange = parseFloat(ntkExchange);
        if (pExchange <= 0 || isNaN(pExchange))
            return;
        let pToken = parseFloat(totalToken);
        if (pToken < 0 || isNaN(pToken))
            return;

        let amt = pToken * pExchange;
        let pTokenLeft = pToken - (amt / pExchange);
        if (amt < 0.01)
            amt = 0;

        setNToken("" + pTokenLeft.toFixed(2));
        setAmount("" + amt.toFixed(2));
    }

    const changeAmount = (amt : string) => {
        let pAmount = parseFloat(amt);
        if (pAmount < 0 || isNaN(pAmount))
            return;
        let pExchange = parseFloat(ntkExchange);
        if (pExchange <= 0 || isNaN(pExchange))
            return;
        let pToken = parseFloat(totalToken);
        if (pToken < 0 || isNaN(pToken))
            return;

        let pTokenLeft = pToken - (pAmount / pExchange);
        
        setNToken("" + pTokenLeft.toFixed(2));
        setAmount(amt);
    }

    // do the exchange
    const exchange = async () => {
        if (negative())
        {
            showAlert(GetStr(LANGUAGE.TXT_NOT_ENOUGH_NTK));
            return;
        }

        router.push("/ntk_ex_confirm/" + amount, "forward", "push");
    }

    // calculate the negative of ntoken
    const negative = () : boolean => {
        let pToken = parseFloat(nToken);
        if (pToken < 0 || isNaN(pToken))
            return true;
        if (pToken < 0)
            return true;
        // else
        return false;
    }

    return (
        <IonPage>
            <IonContent>
                 <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/ntkbuy" ></IonBackButton>
                    </IonButtons>

                    <IonTitle className="title"></IonTitle>
                </IonToolbar>

                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <IonText><b>{ GetStr(LANGUAGE.TXT_NTOKEN_CAP) }</b></IonText>
                                    <p className="ion-text-center">
                                        <IonText className="balance-text" color={ negative() ? "danger" : "primary" }>{ numberWithCommas(nToken) }</IonText>
                                    </p>
                                    <IonItem lines="none">
                                        <IonLabel>{ GetStr(LANGUAGE.TXT_NTOKEN_EXCHANGE_RATE) }<b>{ ntkExchange }</b></IonLabel>
                                        <IonChip slot="end" onClick={ useMax }>MAX</IonChip>
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>
                            <NumInputCtrl 
                                amount = { amount }
                                caption={ GetStr(LANGUAGE.TXT_USD_EXCHANGE_CAP) } 
                                button={ GetStr(LANGUAGE.TXT_USD_EXCHANGE_BUT) } 
                                onChange={ changeAmount } 
                                deci={ true }
                                onSubmit={ exchange } 
                            />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default NtkExchange;